import { getMCPMonitorDistribution } from "@/api/endpoints/searches";
import { Source } from "@/constants";
import { SearchFilterV4WithDates } from "@/types/SearchFilter";
import {
  Widget,
  WidgetContent,
  WidgetHeader,
  WidgetProps,
  WidgetTitle,
} from "@components/ui/widget";
import { Trans } from "@lingui/react/macro";
import { useQuery } from "@tanstack/react-query";
import { getMCPMonitorFiltersFromSearchFilterV4 } from "./utils";
import ChannelTypeShare from "./partials/ChannelTypeShare";

export default function ChannelTypesByMentionCountWidget({
  searchUuid,
  filters,
  ...rest
}: {
  filters: SearchFilterV4WithDates;
  searchUuid: Uuid;
} & WidgetProps) {
  // Server state
  const {
    data: channelTypeDistribution,
    isLoading: isChannelTypeDistributionLoading,
  } = useQuery({
    queryKey: [searchUuid, "channel-type-distribution", filters],
    queryFn: () =>
      getMCPMonitorDistribution(searchUuid, {
        ...getMCPMonitorFiltersFromSearchFilterV4(filters),
        metric: "mention_count",
      }),
  });

  const shares = channelTypeDistribution?.ok
    ? Object.entries(channelTypeDistribution.data.shares)
        .filter(([, value]) => !!value)
        .toSorted((a, b) => {
          return b[1] - a[1];
        })
    : undefined;

  // Helpers
  const isLoading = isChannelTypeDistributionLoading;

  return (
    <Widget {...rest}>
      <WidgetHeader isLoading={isLoading} skeletonClassName="h-6">
        <WidgetTitle className="text-sm">
          <Trans>Fördelning per medietyp</Trans>
        </WidgetTitle>
      </WidgetHeader>
      <WidgetContent
        isLoading={isLoading}
        className="divide-y gap-0 overflow-y-auto"
        isEmpty={
          !isLoading && (!channelTypeDistribution?.ok || !shares?.length)
        }
      >
        {shares
          ? shares.map(([source, share]) => (
              <ChannelTypeShare
                key={source}
                source={source as Source}
                share={share}
              />
            ))
          : null}
      </WidgetContent>
    </Widget>
  );
}
